import ServicoAPI from "../../../servicos/ServicoAPI"

import { Alert, Backdrop, Button, Card, CircularProgress, Collapse, IconButton, Popover, Typography } from "@mui/material"
import { Component, useContext, useRef, useState } from "react"
import { useEffect } from "react"
import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import { Campo, Container, Label, Select } from "../../../componentes/form/campo"
import CardEndereco from "../../../componentes/form/CardEndereco"

import { motion } from "framer-motion"
import { Spinner } from "../../../componentes/Spinner"
import { ContextoGeral } from "../../../contextos/ContextoGeral"
import Badge from "../../../componentes/uteis/Badge"
import MensagemApp from "../../../servicos/config/MensagemApp.js"
import { configAnim } from "../../../servicos/config/configAnim"
import CheckPermission from "../../../servicos/config/CheckPermission.js"
import { isIOS } from "../../../servicos/config/nativeBridge.js"
import { MdContentCopy, MdDraw, MdErrorOutline, MdPhoto, MdQrCode, MdQrCode2, MdSend } from "react-icons/md"
import { BootClickAlert, FakeGpsAlert } from "../../../componentes/gerais/Dialog"
import { copy, print, reduceImage, verificarBootClick } from "../../../servicos/Uteis"
import Protocolo from "./Protocolo"
import { CameraAlt, Close, Collections, Undo } from "@mui/icons-material"
import { baseURL } from "../../../servicos/API"
import axios from "axios"
import Camera from "../../../componentes/gerais/Camera.jsx"
import useCamera from "../../../hooks/general/useCamera.jsx"
import useGallery from "../../../hooks/general/useGallery.jsx"
import AppAPI from "../../../servicos/AppAPI.js"
import { ChatContext } from "../../../contextos/ContextoChat";
import SucessoServicoFinalizado from "../../../componentes/servicos/SucessoServicoFinalizado";
import { prepararSomSucesso } from "../../../componentes/servicos/somSucessoServico";

export default function ServicoFinalizar() {
	const navegar = useNavigate()

	const { socket } = useContext(ChatContext)

	const [debug, setDebug] = useState(<></>)
	const [modalProtocolo, openModalProtocolo] = useState(false)

	const [carregando, setCarregando] = useState(true)
	const [resultado, setResultado] = useState("")
	const [resposta, setResposta] = useState("")
	const [ifoodURL, setIfoodURL] = useState("")

	const [camera, openCamera] = useState(false)

	const [BD, setBD] = useState(false)

	const [data, setData] = useState({})

	const [nome, setNome] = useState('')
	const [motivo, setMotivo] = useState('')
	const [imgFile, setImgFile] = useState("")
	const [confMotivo, setConfMotivo] = useState({
		show: false,
		enabled: false,
		msg: ""
	})

	const [idEndereco, setIdEndereco] = useState(null)

	const [disabledBtnFinalizado, setDisabledBtnFinalizado] = useState(false)

	const [motivoAtributo, setMotivoAtributo] = useState('')
	const [tipoVeiculo, setTipoVeiculo] = useState('')

	const { id } = useParams()

	const { state } = useLocation()

	const { dados, erroRequisicao, setErroRequisicao } = useContext(ContextoGeral)

	const [protocoloLoading, setProtocoloLoading] = useState(false)
	const [origemFalha, setOrigemFalha] = useState(null)

	const [exibirFakeGPS, setExibirFakeGPS] = useState(false)
	const [exibirBootClick, setExibirBootClick] = useState(false)
	const [sucessoServico, setSucessoServico] = useState(null)
	const [sucessoManual, setSucessoManual] = useState(false)

	const showBtnFinalizar = () => {
		if (data) {
			if (data?.codigoFinalizar)
				return data?.codigoFinalizar?.exibirBotao

			if (data?.codigoFinalizarIfood)
				return data?.codigoFinalizarIfood?.exibirBotao
			return true
		}
		return false
	}

	const handleNome = (event) => {
		setNome(event.target.value)
		localStorage.setItem("nomeFinalizar", event.target.value)
	}

	const handleMotivo = event => {
		const atributo = event.target[event.target.selectedIndex].getAttribute('atributo')
		// Busca pelo próprio motivo: o select é filtrado (P2 some no ponto 1), então o índice não bate com data.motivos.opcoes
		const opcao = data.motivos.opcoes.find(opt => opt.label === event.target.value)
		setConfMotivo(prev => ({
			...prev,
			enabled: opcao?.confirmacao ?? false,
			msg: opcao?.msg ?? ''
		}))
		setMotivo(event.target.value)
		setMotivoAtributo(atributo)
	}

	const dominioNewFoto = [
		// "mototaxionline.srv.br",
		// "logmapp.com.br",
		// "efatagynexpress.com.br",
		// "sidlog.com.br",
		// "kolletaexpress.com.br"
	].includes(dados.dominio)

	const vDominio = (window.AndroidInterface?.recoverVersion() >= 102.23) && dominioNewFoto

	const registrarOrigemErro = (origem, detalhe = "") => {
		if (!origem) return
		setOrigemFalha({
			origem,
			detalhe,
			momento: new Date().toLocaleString("pt-BR")
		})
	}

	const limparOrigemErro = () => {
		if (origemFalha) setOrigemFalha(null)
	}

	async function finalizar() {
		prepararSomSucesso()
		setResposta(<div className="mt-4">
			<Spinner />
		</div>)

		try {
			//console.log("finalizar-btn-clicado");
			setDisabledBtnFinalizado(true)

			let statusPermissao = true

			if (statusPermissao && !CheckPermission.checkLocationAvailable()) {
				statusPermissao = false

				if (typeof window.AndroidInterface !== 'undefined')
					window.AndroidInterface.showPermissaoLocalizacao(MensagemApp.msgPermissaoGPS)
			}

			if (statusPermissao && !CheckPermission.checkLocationEnabled()) {
				statusPermissao = false

				window.AndroidInterface?.showHabilitarLocalizacao(MensagemApp.msgHabilitarGPS)
			}

			if (statusPermissao && !CheckPermission.checkStorage()) {
				statusPermissao = false
				window.AndroidInterface?.showPermissaoArmazenamento(MensagemApp.msgPermissaoArmazenamento)
			}

			if (statusPermissao) {
				let location = {
					latitude: 0,
					longitude: 0
				}

				if (window.AndroidInterface) location = JSON.parse(await window.AndroidInterface.getLocation())

				if (window.isLocalHost)
					location = { latitude: -21, longitude: -44 }

				if ((location == '') || (location.latitude == 0 || location.longitude == 0))
					print("Localização indisponível, favor ative a localização para prosseguir.")
				else {
					let dadosServico = {}
					if (motivo != '' && motivoAtributo != '') {
						dadosServico = {
							idServico: id,
							idEndereco: state.idEndereco,
							la: location.latitude,
							lo: location.longitude,
							observacao: nome,
							motivo: {
								label: motivo,
								value: motivoAtributo
							}
						}
					} else {
						dadosServico = {
							idServico: id,
							idEndereco: state.idEndereco,
							la: location.latitude,
							lo: location.longitude,
							observacao: nome,
						}
					}

					// Validação dos campos obrigatórios
					const camposFaltando = []

					if (!dados?.idProf || dados.idProf == "") camposFaltando.push("idProf")
					if (!dadosServico?.idServico || dadosServico.idServico == "") camposFaltando.push("idServico")
					if (!dadosServico?.idEndereco || dadosServico.idEndereco == "") camposFaltando.push("idEndereco")
					if (!dadosServico?.la || dadosServico.la == "") camposFaltando.push("la")
					if (!dadosServico?.lo || dadosServico.lo == "") camposFaltando.push("lo")

					if (camposFaltando.length > 0) {
						registrarOrigemErro("React", `Campos obrigatórios ausentes ou vazios: ${camposFaltando.join(", ")}`)
						setResposta("")
						setDisabledBtnFinalizado(false)
						return
					}

					let retorno = await ServicoAPI.finalizarEndereco(dados, dadosServico)

					if (retorno?.resultado) {
						if (retorno?.resultado) {
							limparOrigemErro()

							const ultimoPonto = !(Number(retorno.dados?.qtdeEndRestantes) > 0)

							if (ultimoPonto) {
								setSucessoManual(false)
								setSucessoServico(retorno?.mensagem || "Serviço finalizado com sucesso.")
							} else {
								if (window.AndroidInterface)
									window.AndroidInterface.showAndroidVersion(retorno.mensagem)

								setResposta(
									<Alert severity="success">
										{retorno?.mensagem}
									</Alert>
								)
								navegar(`/app/servicos/${id}`, { state: {} })
							}

						} else if (retorno?.codigo == 400 || retorno?.codigo == 404) {

							let msg = MensagemApp.msgErroApi
							let msgArray = []

							if (retorno?.dados.erros) {
								msg = MensagemApp.msgErroLista
								retorno.dados.erros.forEach(element => {
									msgArray.push(<li>{element.mensagem}</li>)
								})
							} else if (retorno?.mensagem) {
								msg = retorno.mensagem
							}

							setResposta(
								<Alert severity="error">
									{msg}
									{msgArray}
								</Alert>
							)
							setDisabledBtnFinalizado(false)
						} else {
							if (window.AndroidInterface)
								window.AndroidInterface.showAndroidVersion(MensagemApp.msgErroApi)

							setResposta(<Alert severity="error">
								{retorno?.mensagem ?? MensagemApp.msgErroApi}
							</Alert>)
							setDisabledBtnFinalizado(false)
						}
					} else {
						if (!!window.AndroidInterface)
							window.AndroidInterface.showAndroidVersion(retorno?.mensagem ?? MensagemApp.msgErroApi)

						setResposta(<Alert severity="error">
							{retorno?.mensagem ?? MensagemApp.msgErroApi}
						</Alert>)

						setDisabledBtnFinalizado(false)
					}
				}
			} else {
				setResposta(<Alert severity="error">
					{MensagemApp.msgErroLaLo}
				</Alert>)
				setDisabledBtnFinalizado(false)
			}

		} catch (err) {
			console.error(err)
		}
	}


	async function coletarArquivo(event, tipoColeta, rota, dadosAdicionais = {}) {
		if (tipoColeta == 'A') {
			let json = {
				...state,
				...dadosAdicionais,
				campoNome: nome,
				campoMotivo: motivo,
				campoMotivoAtributo: motivoAtributo,
				obrigatorio: data.btnAssinatura?.obrigatorio
			}

			navegar(`/app/servicos/${id}/assinar`, { state: json })
		} else {
			event.target.blur()

			if (CheckPermission.checkCamera()) {
				setBD(true)

				if (window.AndroidInterface) {
					window.finalizouEnvio = function (res) {
						try {
							setBD(false)
							if (res != "") {
								let retorno = JSON.parse(res)

								if (retorno?.resultado) {
									setResposta(<Alert severity="success" className="text-center">
										{retorno.mensagem}
									</Alert>)
									setCarregando(true)
								} else {
									if (retorno?.mensagem) {
										window.AndroidInterface.showAndroidVersion(retorno.mensagem)

										setResposta(<Alert severity="error" className="text-center">
											{retorno.mensagem}
										</Alert>)
									} else {
										window.AndroidInterface.showAndroidVersion(MensagemApp.msgErroApi)

										setResposta(<Alert severity="error" className="text-center">
											{MensagemApp.msgErroApi}
										</Alert>)
									}

								}
							} else {
								window.AndroidInterface.showAndroidVersion(MensagemApp.msgErroSistemaCamera)

								setResposta(
									<Alert severity="error" className="text-center">
										{MensagemApp.msgErroSistemaCamera}
									</Alert>
								)
							}
							setProtocoloLoading(false)

						} catch (err) {
							setProtocoloLoading(false)
							setResposta(<Alert severity="error" className="text-center">
								Erro ao receber imagem.
							</Alert>)
						}
					}
					setResposta('')
					window.AndroidInterface.ativaCamera('DC', parseInt(dados.idProf), parseInt(id), parseInt(state.idEndereco), tipoColeta, '', rota, dados.token)
				} else {
					setTimeout(() => {
						print('tela de teste, favor testar em um celular android!')
						setBD(false)
					}, 2000)
					setProtocoloLoading(false)
				}
			} else {
				setProtocoloLoading(false)

				if (window.AndroidInterface)
					window.AndroidInterface.showPermissaoCamera(MensagemApp.msgPermissaoCamera)
			}
		}
	}

	async function buscarDadosFinalizacao(motivoProvisorio = "") {

		// Validação dos parâmetros obrigatórios (React)
		// Validação de 'id'
		if (!id || id === null || id === undefined || id === "" || id === 0) {
			registrarOrigemErro("React", `Parâmetro 'id' inválido. Valor recebido: ${id} (tipo: ${typeof id})`)
			setCarregando(false)
			return
		}

		// Validação de 'state.idEndereco' - verifica null, undefined, vazio, 0, NaN
		if (!state || state.idEndereco === null || state.idEndereco === undefined ||
			state.idEndereco === "" || state.idEndereco === 0 ||
			(Number.isNaN(state.idEndereco)) ||
			(typeof state.idEndereco === 'string' && state.idEndereco.trim() === '')) {
			registrarOrigemErro("React", `Parâmetro 'state.idEndereco' inválido. Valor recebido: ${state?.idEndereco} (tipo: ${typeof state?.idEndereco})`)
			setCarregando(false)
			return
		}

		// Validação de 'state.tipoVeiculo' - verifica null, undefined, vazio
		if (!state || state.tipoVeiculo === null || state.tipoVeiculo === undefined ||
			state.tipoVeiculo === "" ||
			(typeof state.tipoVeiculo === 'string' && state.tipoVeiculo.trim() === '')) {
			registrarOrigemErro("React", `Parâmetro 'state.tipoVeiculo' inválido. Valor recebido: ${state?.tipoVeiculo} (tipo: ${typeof state?.tipoVeiculo})`)
			setCarregando(false)
			return
		}

		let location = { latitude: 0, longitude: 0 }

		if (window.isLocalHost)
			location = { latitude: -21, longitude: -43 }



		// Requisição para API (Node)
		let retorno = await ServicoAPI.statusFinalizar(dados, id, state.idEndereco, state.tipoVeiculo, location)

		// Verificação se já foi finalizado
		if (retorno.data.aux && retorno.data.aux == "finalizado") {
			navegar(`/app/servicos/${id}`)
			if (window.AndroidInterface)
				window.AndroidInterface.showAndroidVersion("Este ponto já foi finalizado")
			else
				print("Este ponto já foi finalizado")
			setCarregando(false)
			return
		}

		// Extração dos dados (PHP)
		const dataReturn = retorno.data.dados

		// Se chegou aqui, os dados são válidos
		setData(dataReturn)

		if (dataReturn?.motivos?.opcoes && motivoProvisorio != "")
			dataReturn.motivos.opcoes.map((item, i) => {
				if (item.label == motivoProvisorio)
					setConfMotivo(prev => ({
						...prev,
						enabled: dataReturn.motivos.opcoes[i].confirmacao,
						msg: dataReturn.motivos.opcoes[i].msg
					}))
			})

		if (!dataReturn?.observacao && !dataReturn?.motivos && !dataReturn?.btnAssinatura && !dataReturn?.btnProtocolo && !dataReturn?.btnScanner && !dataReturn?.linkConfirmacao && !dataReturn?.codigoFinalizar && !dataReturn?.codigoFinalizarIfood)
			finalizar()

		setResultado(true)
		setCarregando(false)
	}

	async function verificarFinalizar() {
		prepararSomSucesso()
		let bloqueio = false

		try {
			if (window.AndroidInterface?.recoverVersion() > 100.80) {
				if (dados?.configFakeGPS?.opcao != 'NF' && await window.AndroidInterface.isFakeGPS()) {
					setExibirFakeGPS(true)
					bloqueio = dados?.configFakeGPS?.opcao == "B"
				}

				if (dados?.configBootClick && (dados?.configBootClick?.opcao != 'NF' && await verificarBootClick())) {
					setExibirBootClick(true)

					if (!bloqueio)
						bloqueio = dados?.configBootClick?.opcao == "B"
				}
			}
		} catch {
			console.log(MensagemApp.funcIndisponivel)
		}

		if (bloqueio) return

		if (confMotivo.enabled) setConfMotivo(prev => ({ ...prev, show: true }))
		else finalizar()
	}

	function fecharSucesso() {
		const previa = sucessoManual
		setSucessoServico(null)
		setSucessoManual(false)
		if (previa) return

		navegar(`/app/servicos`, { state: {} })
		socket?.emit("closeRoom", {
			tipoSala: "servico",
			idServico: id
		})
	}

	useEffect(() => {
		if (new URLSearchParams(window.location.search).get("verSucesso") !== "1") return
		setSucessoManual(true)
		setSucessoServico("Serviço finalizado com sucesso.")
	}, [])

	useEffect(() => {
		window.cancelProtocol = async () => {
			setProtocoloLoading(false)
			setBD(false)
		}

		if (state) {
			if (state.tipoVeiculo)
				setTipoVeiculo(state.tipoVeiculo)
			if (state.idEndereco)
				setIdEndereco(state.idEndereco)
		}

		if (carregando) {
			async function buscarDados() {
				buscarDadosFinalizacao(state?.campoMotivo ?? "")
			}

			if (state?.campoNome)
				setNome(state.campoNome)

			if (state?.campoMotivo && motivo == "") {
				setMotivo(state?.campoMotivo ?? "")
				setMotivoAtributo(state?.campoMotivoAtributo ?? "")
			}

			buscarDados()
		}
	}, [carregando])

	// acima do return / dentro do componente:
	const qtdBotoes =
		(data?.btnAssinatura ? 1 : 0) +
		(data?.btnProtocolo ? 1 : 0) +
		(data?.btnScanner ? 1 : 0);

	const gridCols =
		qtdBotoes === 1 ? 'grid-cols-1'
			: qtdBotoes === 2 ? 'grid-cols-2'
				: 'grid-cols-3';


	return <>
		{sucessoServico && (
			<SucessoServicoFinalizado
				mensagem={sucessoServico}
				manual={sucessoManual}
				onConcluir={fecharSucesso}
			/>
		)}
		<motion.div
			style={{ backgroundColor: '#eee', height: 'var(--app-vh)', width: '100vw', padding: '1rem', paddingTop: 'calc(1rem + var(--safe-top, 0px))' }}
			initial={configAnim.initial}
			animate={configAnim.animate}
			exit={configAnim.exit}
			transition={configAnim.transition}
		>
			<>
				{imgFile && <img className="w-full" src={imgFile} />}
				{carregando
					? <Spinner />
					: <>
						{resultado
							? <>
								<div>
									<div
										className="absolute right-2"
										style={{ top: 'calc(0.25rem + var(--safe-top, 0px))', right: "1rem", zIndex: 500 }}
									>
										<Link to={`/app/servicos/${id}`} style={{ width: 'auto' }}>
											<button className='btn-close'>
												{/* <Close color=" text-gray-500" /> */}
											</button>
										</Link>
									</div>
									<div>
										<div style={{ marginTop: "2rem" }}>
											<CardEndereco
												id={state?.idAtivo}
												endereco={state?.endereco}
												icone
												observacao={state?.observacao}
											/>
										</div>

										<Collapse in={ifoodURL == ""}>
											{data?.codigoFinalizarIfood && <EstruturaCodigo
												label={data?.codigoFinalizarIfood?.labelInput?.trim() || "Código de coleta do iFood"}
												info={data?.codigoFinalizarIfood?.msgInfo}
												metodo="POST"
												uri="/verificaCodigoEntrega"
												idEndereco={state.idEndereco}
												reload={() => {
													setCarregando(true)
												}}
											/>}

											{data?.codigoFinalizar && <EstruturaCodigo
												label={data?.codigoFinalizar?.labelInput}
												info={data?.codigoFinalizar?.msgInfo}
												metodo="PUT"
												uri="/informarCodigoFinalizarEnd"
												idEndereco={state.idEndereco}
												reload={() => {
													setCarregando(true)
												}}
											/>}

											<div>
												{data?.observacao && <>
													<label>
														{
															data.observacao.titulo
																? data.observacao.titulo
																: "Observação"
														}
													</label>
													<Campo
														label={data.observacao.label}
														value={nome}
														obrigatorio={data.observacao?.obrigatorio}
														onChange={handleNome}
													/>
												</>}

												{data?.motivos !== undefined && <div className="mt-3">
													<Container>
														<Select
															id="motivo"
															className="select"
															onChange={handleMotivo}
															value={motivo}
														>
															<option value="" disabled>selecione...</option>
															{data.motivos.opcoes
																.filter(opt => !(Number(state?.idAtivo) === 1 && opt.aparecerMotivo === 'P2'))
																.map((option, i) => (
																	<option
																		key={`option.label-${i}`}
																		value={option.label}
																		atributo={option.value}
																	>
																		{option.label}
																	</option>
																))}
														</Select>
														<Label htmlFor="motivo">
															Selecione um motivo
															{data.motivos?.obrigatorio ? (
																<span className="red">✶</span>
															) : ''}
														</Label>
													</Container>
												</div>}
											</div>

											<div className={`grid w-full gap-2 mt-3 ${gridCols}`}>
												{data?.btnAssinatura && (
													<button
														onClick={(ev) => {
															coletarArquivo(ev, 'A', '', data.btnAssinatura.infoAdicional);
														}}
														className="relative flex items-center justify-center gap-1 flex-1 min-w-[80px] px-2 py-1"
														disabled={
															data.btnAssinatura?.qtdeMax &&
															data.btnAssinatura?.qtdeEnviada >= data.btnAssinatura?.qtdeMax
														}
													>
														<MdDraw size={20} /> {/* aumentei levemente o tamanho do ícone */}
														<span className="text-[11px] leading-none text-center">
															{data.btnAssinatura?.label ?? ""}
															{data.btnAssinatura?.obrigatorio && <span className="red">*</span>}
														</span>
														{data.btnAssinatura?.qtdeEnviada > 0 && (
															<Badge
																right="5px"
																top="-8px"
																color="green"
																valor={data.btnAssinatura.qtdeEnviada}
															/>
														)}
													</button>

												)}

												{data?.btnProtocolo && (
													<button
														className="relative flex items-center justify-center gap-1 flex-1 min-w-[80px] px-2 py-1"
														onClick={(e) => {
															if (!vDominio) {
																setProtocoloLoading(true);
																try {
																	if (window.AndroidInterface?.recoverVersion() > 102.0)
																		openModalProtocolo(true);
																	else coletarArquivo(e, 'P', 'salvarDadosFinalizar');
																} catch (err) {
																	const msg = "Erro ao iniciar câmera, atualize seu aplicativo!";
																	try {
																		window.AndroidInterface.showAndroidVersion(msg);
																	} catch {
																		alert(msg);
																	}
																	setProtocoloLoading(false);
																}
															}
														}}
														disabled={
															data.btnProtocolo?.qtdeEnviada >= data.btnProtocolo?.qtdeMax ||
															protocoloLoading
														}
													>
														{vDominio && (
															<div className="absolute w-full h-screen">
																{!(
																	(data.btnProtocolo?.qtdeMax
																		? data.btnProtocolo?.qtdeEnviada >= data.btnProtocolo?.qtdeMax
																		: false) || protocoloLoading
																) && (
																		<Camera
																			setState={setProtocoloLoading}
																			func={async (base) => {
																				await axios
																					.post(
																						baseURL + '/appProfissional/acessar',
																						{
																							dominio: dados.dominio ?? 'mototaxionline.srv.br',
																							rota: '/salvarDadosFinalizar',
																							metodo: 'POST',
																							cabecalho: {
																								token: dados.token,
																							},
																							data: {
																								idEndereco: idEndereco,
																								idProf: dados.idProf,
																								idServico: id,
																								identificador: 'P',
																								imagem: base,
																								length: base.length,
																							},
																						},
																						{ timeout: 30000 }
																					)
																					.then((res) => res.data)
																					.then((res) => {
																						try {
																							window.AndroidInterface.showAndroidVersion(res.mensagem);
																						} catch {
																							alert(res.mensagem);
																						}
																					})
																					.catch((rej) => rej)
																					.finally(() => {
																						setProtocoloLoading(false);
																						setCarregando(true);
																					});
																			}}
																		/>
																	)}
															</div>
														)}
														<MdPhoto size={20} />
														<span className="text-[11px] leading-none text-center">
															{protocoloLoading ? (
																<CircularProgress size={18} />
															) : (
																<>
																	{data.btnProtocolo?.label ?? ""}
																	{data.btnProtocolo?.obrigatorio && <span className="red">*</span>}
																</>
															)}
														</span>
														{data.btnProtocolo?.qtdeEnviada > 0 && (
															<Badge
																right="5px"
																top="-8px"
																color="green"
																valor={data.btnProtocolo.qtdeEnviada}
															/>
														)}
													</button>

												)}

												{data?.btnScanner && (
													<button
														onClick={(ev) => {
															coletarArquivo(ev, 'S', 'salvarDadosFinalizar');
														}}
														className="relative flex items-center justify-center gap-1 flex-1"
														disabled={
															data.btnScanner?.qtdeMax
																? data.btnScanner?.qtdeEnviada >= data.btnScanner?.qtdeMax
																: false
														}
													>
														<MdQrCode size={18} />
														<small className="text-[10px]">
															{data.btnScanner?.label}
															{data.btnScanner?.obrigatorio && <span className="red">*</span>}
														</small>
														{data.btnScanner?.qtdeEnviada > 0 && (
															<Badge
																right="5px"
																top="-8px"
																color="green"
																valor={data.btnScanner.qtdeEnviada}
															/>
														)}
													</button>
												)}
											</div>


											{showBtnFinalizar() ? (
												<button
													className="w-full bg-blue-600 text-white py-2 mt-3 rounded disabled:opacity-50"
													disabled={disabledBtnFinalizado}
													onClick={verificarFinalizar}
												>
													Finalizar
												</button>
											) : data?.codigoFinalizar?.msgBotao ? (
												<div style={{ backgroundColor: '#bbe0ed', color: 'oklch(0.36 0.04 247.8)' }} className="border border-blue-300 rounded p-3 text-center mt-3">
													{data?.codigoFinalizar?.msgBotao}
												</div>
											) : data?.codigoFinalizarIfood?.msgBotao ? (
												<div style={{ backgroundColor: '#bbe0ed', color: 'oklch(0.36 0.04 247.8)' }} className="border border-blue-300 rounded p-3 text-center mt-3">
													{data?.codigoFinalizarIfood?.msgBotao}
												</div>
											) : null}

											{!data && (
												<div className="bg-red-100 text-red-800 border border-red-300 rounded p-3 text-center mt-3">
													Nenhuma informação de finalização disponível.
												</div>
											)}

										</Collapse>
									</div>
								</div>
							</>
							: <div className="alert alert-danger text-center">
								Erro ao buscar informações, localização indisponível.
								<Button onClick={() => navegar("/app/servicos")} fullWidth>Voltar</Button>
							</div>}

						<FakeGpsAlert
							open={exibirFakeGPS}
							setOpen={setExibirFakeGPS}
							opcao={dados?.configFakeGPS?.opcao}
							onClose={() => {
								if (!exibirBootClick && !exibirFakeGPS) finalizar()
							}}
						/>

						<BootClickAlert
							open={exibirBootClick}
							setOpen={setExibirBootClick}
							opcao={dados?.configBootClick?.opcao}
							onClose={() => {
								if (!exibirBootClick && !exibirFakeGPS) finalizar()
							}}
						/>

						<div className="mt-3">
							<motion.div
								initial={{ opacity: 0 }}
								animate={{ opacity: 1 }}
								exit={{ opacity: 0 }}
							>
								{resposta}
							</motion.div>
							{origemFalha && (
								<Alert severity="info" className="mt-3" icon={false}>
									<div><strong>Origem provável:</strong> {origemFalha.origem}</div>
									{origemFalha.detalhe && <div>{origemFalha.detalhe}</div>}
									{origemFalha.momento && (
										<div className="text-xs opacity-70">
											Registrado em {origemFalha.momento}
										</div>
									)}
								</Alert>
							)}
						</div>
						<Backdrop
							open={BD}
						>
							<div style={{ height: '100%' }}>
								<Spinner />
							</div>
						</Backdrop>
					</>}

				<ModalIfood url={ifoodURL} back={() => {
					setCarregando(true)
					setIfoodURL("")
				}} state={state} />
			</>
		</motion.div >
		<Backdrop in={confMotivo.show}>
			<Card className="m-3 p-3 relative">
				<IconButton className="absolute end-0 top-0" onClick={() => {
					setConfMotivo(prev => ({ ...prev, show: false }))
				}}>
					<Close />
				</IconButton>
				<div className="mt-3 text-center lh-1">
					{confMotivo.msg}
				</div>
				<div className="flex gap-3 mt-3">
					<Button
						variant="contained"
						color="success"
						onClick={() => {
							setConfMotivo(prev => ({
								...prev,
								show: false
							}))
							finalizar()
						}}
						fullWidth
					>
						Sim
					</Button>
					<Button
						variant="contained"
						onClick={() => {
							setConfMotivo(prev => ({
								...prev,
								show: false
							}))
						}}
						fullWidth
					>
						Não
					</Button>
				</div>
			</Card>
		</ Backdrop>
		<Backdrop in={modalProtocolo}>
			<BoundaryProtocol>
				<ProtocolContainer
					opcao={data?.btnProtocolo?.opcaoTipoFoto}
					handleClose={() => {
						openModalProtocolo(false)
						setProtocoloLoading(false)
						setErroRequisicao(null)
					}}
					reload={() => {
						openCamera(false)
						setCarregando(true)
						openModalProtocolo(false)
						setProtocoloLoading(false)
						setErroRequisicao(null)
					}}
					onObsolete={() => {
						try {
							openModalProtocolo(false)
							openCamera(true)
						} catch (err) {
							try {
								window.AndroidInterface.showAndroidVersion("Não foi possível acionar a câmera do dispositivo")
							} catch {
								alert("Não foi possível acionar a câmera do dispositivo")
							}
						}
					}}
					handleDB={async (URL) => {
						const resp = await ServicoAPI.salvarFotoProtocolo(dados, {
							link: URL,
							idEndereco: idEndereco,
							idProf: dados.idProf,
							idServico: id
						})

						if (resp.codigo != 200)
							try {
								window.AndroidInterface.showAndroidVersion(resp.mensagem ?? "não foi possível salvar a imagem, tente novamente mais tarde.")
							} catch {
								alert(resp.mensagem ?? "não foi possível salvar a imagem, tente novamente mais tarde.")
							}
					}}
					erroRequisicao={erroRequisicao}
					setErroRequisicao={setErroRequisicao}
				/>
			</BoundaryProtocol>
		</Backdrop>
		{/* <Protocolo open={camera} openCamera={openCamera} idEndereco={idEndereco} setProtocoloLoading={setProtocoloLoading} id={id} load={setCarregando} /> */}
	</>
}

function ProtocolContainer({ opcao, handleClose, reload, handleDB, onObsolete, erroRequisicao, setErroRequisicao }) {
	const [open, setOpen] = useState(false)
	const [openGallery, setOpenGallery] = useState(false)
	const [errorMsg, setErrorMsg] = useState("")
	const [tentouEnviar, setTentouEnviar] = useState(false)

	// Resetar tentouEnviar quando o modal fechar
	const handleCloseWithReset = () => {
		setTentouEnviar(false)
		setErrorMsg("")
		handleClose()
	}

	// Limpar erro quando não for relacionado ao protocolo ou quando abrir câmera/galeria
	useEffect(() => {
		if (erroRequisicao && !tentouEnviar) {
			const isErroProtocolo = 
				erroRequisicao?.requisicao?.url?.includes("salvarImagemCDN") || 
				erroRequisicao?.requisicao?.url?.includes("salvarFotoProtocolo") ||
				erroRequisicao?.url === "/salvarImagemCDN" ||
				erroRequisicao?.requisicao?.endpoint?.includes("salvarImagemCDN") ||
				erroRequisicao?.requisicao?.endpoint?.includes("salvarFotoProtocolo")
			
			if (!isErroProtocolo && setErroRequisicao) {
				setErroRequisicao(null)
			}
		}
	}, [erroRequisicao, tentouEnviar, setErroRequisicao])

	async function handleCamera() {
		if (isIOS() || await CheckPermission.checkCamera()) {
			if (window.AndroidInterface?.recoverVersion() >= 102.26) {
				setOpen(true)
			} else {
				onObsolete()
			}
		} else try {
			window.AndroidInterface.showPermissaoCamera(MensagemApp.msgPermissaoCamera)
		} catch {
			print("É necessário ativar a permissão de câmera neste aplicativo!")
		}
	}

	async function handleGallery() {
		setOpenGallery(true)
	}

	return <Card className="m-3 p-3 relative" style={{ maxHeight: "90vh", overflow: "auto" }}>
		<IconButton disabled={open || openGallery} className="!absolute !mt-[-10px] !right-3" style={{ zIndex: 1000 }} onClick={handleCloseWithReset}>
			<Close />
		</IconButton>
		<h5 className="mt-4 mx-1">Qual forma deseja buscar sua imagem de protocolo?</h5>
		<div className="flex gap-3">
			{opcao != "G" && window.AndroidInterface && <Button
				variant="contained"
				className="mt-3"
				disabled={open || openGallery}
				startIcon={<CameraAlt />}
				onClick={handleCamera}
				fullWidth
			>
				Câmera
			</Button>}
			{opcao != "C" && <Button
				variant="contained"
				className="mt-3"
				disabled={open || openGallery}
				onClick={handleGallery}
				startIcon={<Collections />}
				fullWidth
			>
				Galeria
			</Button>}
		</div>

		{open && <ProtocolCamera
			onFinish={async (URL) => {
				setErrorMsg("")
				setTentouEnviar(true)
				await handleDB(URL)
				setOpen(false)
				setTentouEnviar(false)
				reload()
			}}
			onError={msg => {
				setErrorMsg(msg)
				setTentouEnviar(true)
				setOpen(false)
			}}
		/>}

		{openGallery && <ProtocolGallery
			onFinish={async (URL) => {
				setErrorMsg("")
				setTentouEnviar(true)
				await handleDB(URL)
				setOpenGallery(false)
				setTentouEnviar(false)
				reload()
			}}
			onError={msg => {
				setErrorMsg(msg)
				setTentouEnviar(true)
				setOpenGallery(false)
			}}
		/>}
		{!open && !openGallery && errorMsg && errorMsg.length > 0 && <Alert severity="error" className="mt-3" icon={false}>
			{errorMsg}
		</Alert>}
		{!open && !openGallery && tentouEnviar && erroRequisicao && (
			(erroRequisicao?.requisicao?.url?.includes("salvarImagemCDN") || 
			erroRequisicao?.requisicao?.url?.includes("salvarFotoProtocolo") ||
			erroRequisicao?.url === "/salvarImagemCDN" ||
			erroRequisicao?.requisicao?.endpoint?.includes("salvarImagemCDN") ||
			erroRequisicao?.requisicao?.endpoint?.includes("salvarFotoProtocolo"))
		) && (
		<div className="mt-3 p-3 bg-blue-50 border border-blue-200 rounded" style={{ 
			fontSize: "0.875rem",
			textAlign: "center"
		}}>
			<div style={{ color: "#1976d2", fontWeight: 500 }}>
				Nossa equipe já foi notificada sobre o problema
			</div>
		</div>
		)}
	</Card>
}

function ProtocolCamera({ onFinish, onError }) {
	useCamera(onFinish, onError)

	return <div className="text-center mt-3">
		<CircularProgress />
	</div>
}

function ProtocolGallery({ onFinish, onError }) {
	useGallery(onFinish, onError)

	return <div className="text-center mt-3">
		<CircularProgress />
	</div>
}

function ModalIfood({ url, back, state }) {
	return <Backdrop style={{
		zIndex: 1000
	}} in={url != ""}>
		<div className="relative" style={{
			background: "white",
			padding: "0 1rem"
		}}>
			<Button
				startIcon={<Undo />}
				onClick={back}
				fullWidth
			>
				Voltar
			</Button>

			<CardEndereco
				id={state?.idAtivo}
				endereco={state?.endereco}
				icone
				observacao={state?.observacao}
			/>
			<div id="ifood" style={{
				height: "calc(var(--app-vh) - 13rem)",
				overflow: "auto"
			}}>
				<iframe src={url} style={{
					width: "100%",
					background: "white",
					height: "var(--app-vh)",
					overflow: "hidden",
					scrollbarWidth: "10px"
				}} />
			</div>
		</div>
	</Backdrop>
}

class BoundaryProtocol extends Component {
	constructor(props) {
		super(props);
		this.state = {
			hasError: false,
			error: null,
			errorInfo: null,
		};
	}

	static getDerivedStateFromError(error) {
		return { hasError: true, error, errorInfo: null };
	}

	componentDidCatch(error, errorInfo) {
		this.setState({ error, errorInfo });
		// Log error to an external service if needed
		console.error('Error caught by BoundaryProtocol:', error, errorInfo);
	}

	render() {
		const { hasError, error } = this.state;

		if (hasError) {
			return (
				<div
					style={{
						padding: '20px',
						border: '2px solid red',
						backgroundColor: '#ffe5e5',
						borderRadius: '5px',
						fontFamily: 'Arial, sans-serif',
						textAlign: 'center',
					}}
				>
					<h1>Something went wrong!</h1>
					<p>{error?.message || 'An unexpected error occurred.'}</p>
					<p style={{ fontSize: 'smaller', color: '#555' }}>
						Please try refreshing the page or contact support if the issue persists.
					</p>
				</div>
			);
		}

		return this.props.children;
	}
}

function EstruturaCodigo({ label, info, uri, idEndereco, metodo, reload }) {
	const { id } = useParams()
	const { dados } = useContext(ContextoGeral)

	const [anchorEl, setAnchorEl] = useState(null)
	const [codigo, setCodigo] = useState("")

	const [codErr, setCodErr] = useState(false)
	const [codMsg, setCodMsg] = useState('')
	const [codLoading, setCodLoading] = useState(false)

	const infoPop = Boolean(anchorEl)

	async function handleCodigo(e) {
		if (e.target.value.length < 5)
			setCodigo(e.target.value)
	}

	return <>
		<div className="mt-3 flex gap-3">
			<div style={{ width: "calc(100% - 4rem)" }}>
				<div className="relative w-full" ref={anchorEl}>
					<Campo
						label={label}
						value={codigo}
						tipo="number"
						onChange={handleCodigo}
						danger={codErr}
					/>
					<IconButton
						onClick={e => setAnchorEl(e.target ?? null)}
						style={{ position: "absolute", right: "6px", top: "50%", transform: "translateY(-50%)" }}
					>
						<MdErrorOutline />
					</IconButton>

					<Popover open={infoPop} anchorEl={anchorEl} onClose={() => setAnchorEl(null)} anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}>
						<Typography sx={{ p: 2, lineHeight: 1 }}>
							{info
								? info
								: "Digite aqui o código de 4 dígitos associados ao endereço."}
						</Typography>
					</Popover>
				</div>
			</div>
			<div className="flex items-center">
				<IconButton disabled={codLoading} onClick={async () => {
					setCodMsg("")
					setCodLoading(true)

					let location = {
						latitude: 0,
						longitude: 0
					}

					if (window?.AndroidInterface) location = JSON.parse(await window.AndroidInterface.getLocation())

					if (window.isLocalHost)
						location = { latitude: -21, longitude: -44 }

					await ServicoAPI.informarCodigo(uri, metodo, dados, {
						idProf: dados.idProf,
						idServico: id,
						idEndereco: idEndereco,
						codigoDigitado: codigo,
						code: codigo,
						la: location.latitude,
						lo: location.longitude
					}).then(r => {
						let err = !r?.resultado


						if (r.mensagem?.status)
							err = !r.mensagem?.status

						if (!err) {
							print("Sucesso!")

							setTimeout(() => {
								reload()
							}, 2000)
						}

						if (typeof r?.mensagem == "string")
							setCodMsg(r.mensagem)
						else setCodMsg(r?.mensagem?.msg ?? "Falha ao confirmar código!")
						setCodErr(err)
					}).catch(r => {
						setCodMsg("Falha ao se conectar")
					}).finally(() => setCodLoading(false))
				}}>
					<MdSend />
				</IconButton>
			</div>
		</div>
		<Collapse in={codLoading}>
			<div className="mt-3 text-center">
				<CircularProgress />
			</div>
		</Collapse>
		<Collapse in={codMsg != "" && !codLoading}>
			<Card
				className={`mt-3 p-2 text-center font-normal !text-white ${codErr ? '!bg-red-600' : '!bg-green-600'
					}`}
			>
				{codMsg}
			</Card>
		</Collapse>
	</>
}
